import { CHANGE_SHOW_SAFEWORD } from "../actions/types";

const INITIAL_STATE = {
  showSafeword: true,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHANGE_SHOW_SAFEWORD:
      return { ...state, showSafeword: !state.showSafeword };
    default:
      return state;
  }
}
